document.addEventListener("DOMContentLoaded", function () {
    var mokkaWidget = document.getElementById("mokka_widget");

    if (mokkaWidget) {
        var productViewProduct = document.querySelector(".productView-product");

        if (productViewProduct) {
            var moreItems = productViewProduct.querySelectorAll(".productView-moreItem");

            var newMoreItem = document.createElement("div");
            newMoreItem.classList.add("productView-moreItem");

            // Move mokka_widget inside the new div
            newMoreItem.appendChild(mokkaWidget);

            if (moreItems.length >= 3) {
                moreItems[2].after(newMoreItem);
            } else {
                productViewProduct.appendChild(newMoreItem);
            }

            // Ensure the element is hidden before triggering the fade-in
            mokkaWidget.style.opacity = "0";

            // Fade-in after a slight delay
            setTimeout(() => {
                mokkaWidget.style.opacity = "1";
            }, 100);
        }
    }
});
